import { render, staticRenderFns } from "./CalendarStart.vue?vue&type=template&id=38776be8&"
import script from "./CalendarStart.vue?vue&type=script&lang=js&"
export * from "./CalendarStart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports